/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Styles from './CarrosEletricosConsultar.css';
import Container from '../../atoms/Container/Container';
import WhiteButton from '../../atoms/WhiteButton/WhiteButton';
import CustomEmblaCarousel from '../CustomEmblaCarousel/CustomEmblaCarousel';

function CarrosEletricosConsultar() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }

  return (
    <>
      <section id="renegociacao-consultar">
        <Container>
          <h3 className="renegociacao-consultar-title">
            Consulte nossos conteúdos sobre veículos elétricos
          </h3>
          <div className="renegociacao-consultar-mobile">
            <CustomEmblaCarousel enableBullets bulletCount={3}>
              {({ className }) => (
                <>
                  <div className={`slide renegociacao-consultar-card ${className}`}>
                    <a href="blog/veiculos-eletricos-saiba-como-funcionam-e-suas-caracteristicas.html">
                      <picture>
                        <source
                          type="image/webp"
                          srcSet="assets/carros-eletricos/saiba-mais-veiculos-eletricos.webp"
                        />
                        <source
                          type="image/jpeg"
                          srcSet="assets/carros-eletricos/saiba-mais-veiculos-eletricos.jpg"
                        />
                        <img
                          className="renegociacao-consultar-card-img"
                          src="assets/carros-eletricos/saiba-mais-veiculos-eletricos.jpg"
                          alt="carregando veículo elétrico"
                        />
                      </picture>
                      <p className="renegociacao-consultar-card-type">Serviços</p>
                      <h4 className="renegociacao-consultar-card-title">
                        Veículos elétricos: saiba como funcionam e suas características
                      </h4>
                      <p className="renegociacao-consultar-card-btn">Saiba mais</p>
                    </a>
                  </div>
                  <div className={`slide renegociacao-consultar-card ${className}`}>
                    <a href="blog/economize-na-conta-de-luz-com-energia-solar.html">
                      <picture>
                        <source type="image/webp" srcSet="assets/carros-eletricos/capa.webp" />
                        <source type="image/jpeg" srcSet="assets/carros-eletricos/capa.jpeg" />
                        <img
                          className="renegociacao-consultar-card-img"
                          src="assets/carros-eletricos/capa.jpeg"
                          alt="sustentabilidade"
                        />
                      </picture>
                      <p className="renegociacao-consultar-card-type">Educação financeira</p>
                      <h4 className="renegociacao-consultar-card-title">
                        Energia solar: como economizar e preservar o meio ambiente
                      </h4>

                      <p className="renegociacao-consultar-card-btn">Saiba mais</p>
                    </a>
                  </div>
                  <div className={`slide renegociacao-consultar-card ${className}`}>
                    <a href="blog/como-financiar-um-veiculo.html">
                      <picture>
                        <source
                          type="image/webp"
                          srcSet="assets/carros-eletricos/saiba-mais-como-financiar.webp"
                        />
                        <source
                          type="image/jpeg"
                          srcSet="assets/carros-eletricos/saiba-mais-como-financiar.jpg"
                        />
                        <img
                          className="renegociacao-consultar-card-img"
                          src="assets/carros-eletricos/saiba-mais-como-financiar.jpg"
                          alt="financiamento de veículos"
                        />
                      </picture>
                      <p className="renegociacao-consultar-card-type">Serviços</p>
                      <h4 className="renegociacao-consultar-card-title">
                        Como financiar um veículo?
                      </h4>

                      <p className="renegociacao-consultar-card-btn">Saiba mais</p>
                    </a>
                  </div>
                </>
              )}
            </CustomEmblaCarousel>
          </div>

          <div className="renegociacao-consultar-desktop">
            <div className="renegociacao-consultar-card">
              <a href="blog/veiculos-eletricos-saiba-como-funcionam-e-suas-caracteristicas.html">
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/carros-eletricos/saiba-mais-veiculos-eletricos.webp"
                  />
                  <source
                    type="image/jpeg"
                    srcSet="assets/carros-eletricos/saiba-mais-veiculos-eletricos.jpg"
                  />
                  <img
                    className="renegociacao-consultar-card-img"
                    src="assets/carros-eletricos/saiba-mais-veiculos-eletricos.png"
                    alt="carregando veículo elétrico"
                  />
                </picture>
                <p className="renegociacao-consultar-card-type">Serviços</p>
                <h4 className="renegociacao-consultar-card-title">
                  Veículos elétricos: saiba como funcionam e suas características
                </h4>
                <p className="renegociacao-consultar-card-btn">Saiba mais</p>
              </a>
            </div>
            <div className="renegociacao-consultar-card">
              <a href="blog/economize-na-conta-de-luz-com-energia-solar.html">
                <picture>
                  <source type="image/webp" srcSet="assets/carros-eletricos/capa.webp" />
                  <source type="image/jpeg" srcSet="assets/carros-eletricos/capa.jpeg" />
                  <img
                    className="renegociacao-consultar-card-img"
                    src="assets/carros-eletricos/capa.jpeg"
                    alt="sustentabilidade"
                  />
                </picture>
                <p className="renegociacao-consultar-card-type">Educação financeira</p>
                <h4 className="renegociacao-consultar-card-title">
                  Energia solar: como economizar e preservar o meio ambiente
                </h4>

                <p className="renegociacao-consultar-card-btn">Saiba mais</p>
              </a>
            </div>
            <div className="renegociacao-consultar-card">
              <a href="blog/como-financiar-um-veiculo.html">
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/carros-eletricos/saiba-mais-como-financiar.webp"
                  />
                  <source
                    type="image/jpeg"
                    srcSet="assets/carros-eletricos/saiba-mais-como-financiar.jpg"
                  />
                  <img
                    className="renegociacao-consultar-card-img"
                    src="assets/carros-eletricos/saiba-mais-como-financiar.jpg"
                    alt="financiamento de veículos"
                  />
                </picture>
                <p className="renegociacao-consultar-card-type">Serviços</p>
                <h4 className="renegociacao-consultar-card-title">Como financiar um veículo?</h4>

                <p className="renegociacao-consultar-card-btn">Saiba mais</p>
              </a>
            </div>
          </div>
        </Container>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default CarrosEletricosConsultar;
